<template>
  <div class="homePage">
    <!-- 主体 -->
    <div class="homeMain" style="margin-top:30px">
      <!-- 头条新闻部分 -->
      <div class="main_panel">
        <div class="Notice">
          <div class="Tit"><img src="../../assets/image/hotTit.jpg" /></div>
          <div class="r">
            <div class="news" id="news">
              <div class="news">
                <div class="news">
                  <a
                    @click="
                      val => {
                        todel(val, newsTextList)
                      }
                    "
                  >
                    <h2>{{ newsTextList.title }}</h2>
                    <p class="homeText" style="font-size:14px">{{ newsTextList.artDesc | ellipsis }}</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 间隔 -->
      <div class="clear"></div>
      <!-- 新闻动态部分 -->
      <div class="main_panel">
        <!-- 新闻列表图片轮播图 -->
        <div class="NewsL">
          <div id="newsFlashItem" style="width:100%; overflow:hidden;">
            <div class="flashImg" style="display: block;">
              <div class="flashImg-container swiper-container" id="newsFlash01">
                <div class="flashImg-wrapper swiper-wrapper">
                  <div class="flashImg-slide swiper-slide" v-for="(item, index) in newsFlashList01" :key="index">
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">
                      <img
                        class="swiper_img"
                        :src="item.thumb1"
                        style="width: 100% ; height: 100% ; overflow:hidden;"
                      />
                      <div class="txt">
                        <p class="txtTitle">{{ item.title }}</p>
                      </div>
                    </a>
                    <a
                      v-else
                      @click="
                        val => {
                          todel(val, item)
                        }
                      "
                    >
                      <img
                        class="swiper_img"
                        :src="item.thumb1"
                        style="width: 100% ; height: 100% ; overflow:hidden;"
                      />
                      <div class="txt">
                        <p class="txtTitle">{{ item.title }}</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 新闻内容列表 -->
        <div class="NewsR">
          <div class="Tit" id="NewsT">
            <div
              class="NewsTInner"
              :class="{ active: catalogActive == index }"
              v-for="(item, index) in catalogList"
              :key="index"
              @mouseenter="mouseenterCatalog(index)"
            >
              <a :href="item.url" target="_blank">{{ item.title }}</a>
            </div>
          </div>
          <div class="ItemList" id="NewsItem">
            <div class="NewsItem">
              <ul class="comUl" v-if="catalogActive == 0">
                <li v-for="(item, index) in newCatalogList01" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <a
                    v-else
                    @click="
                      val => {
                        todel(val, item)
                      }
                    "
                    >{{ item.title }}</a
                  >
                  <span>{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </li>
              </ul>
              <ul class="comUl" v-if="catalogActive == 1">
                <li v-for="(item, index) in newCatalogList02" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <a
                    v-else
                    @click="
                      val => {
                        todel(val, item)
                      }
                    "
                    >{{ item.title }}</a
                  >
                  <span>{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </li>
              </ul>
              <ul class="comUl" v-if="catalogActive == 2">
                <li v-for="(item, index) in newCatalogList03" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <a
                    v-else
                    @click="
                      val => {
                        todeljt(val, item)
                      }
                    "
                    >{{ item.title }}</a
                  >
                  <span>{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </li>
              </ul>
              <ul class="comUl" v-if="catalogActive == 3">
                <li v-for="(item, index) in newCatalogList04" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <a
                    v-else
                    @click="
                      val => {
                        todel(val, item)
                      }
                    "
                    >{{ item.title }}</a
                  >
                  <span>{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 不忘初心 牢记使命   -->
    <div class="width_100 importYeWu"></div>
    <!-- 各种链接，网站集群 -->
    <div class="homeMain">
      <div class="main_panel_top" style="text-align:center">
        <img src="../../assets/image/AbouT.jpg" /><br />
        <span
          class="main_panel_span"
          style="margin-top:10px;display: inline-block;line-height: 25px;margin-bottom:20px;font-size:16px"
          @click="togrop()"
          >甘肃第二建设集团有限责任公司，简称“甘肃二建集团”。始建于1952年，前身为甘肃省第二建<br />筑工程公司，
          系中国500强企业甘肃建投系统内综合实力较强企业之一。</span
        >
      </div>
      <div class="main_panel_content">
        <div class="left">
          <div style="height:113.8px;margin-bottom:35px">
            <div class="button">企业理念</div>
            <br />
            <div class="content">
              <span>企业使命</span>
              <span style="margin-left:20px">回报顾客最优 回报职工最多</span><br />
              <span>企业愿景</span>
              <span style="margin-left:20px">锐意进取，打造行业新兴标杆。品质先行，力创业内一流品牌。</span><br />
              <span>核心价值观</span>
              <span style="margin-left:20px;">进取 担当 求实 创新</span>
            </div>
          </div>
          <div style="height:30px;margin-bottom:35px">
            <div class="button">经营理念</div>
            <div class="content">
              <span>明礼诚信</span>
              <span style="margin-left:20px">阳光共赢</span>
            </div>
          </div>
          <div style="height:30px;margin-bottom:35px">
            <div class="button">人才理念</div>
            <div class="content">
              <span>企业造就人才</span>
              <span style="margin-left:20px">人才成就企业</span>
            </div>
          </div>
          <div style="height:30px;margin-bottom:35px">
            <div class="button">服务理念</div>
            <div class="content">
              <span>服务来自责任</span>
              <span style="margin-left:20px">责任来自良心</span>
            </div>
          </div>
          <div style="height:30px">
            <div class="button">管理理念</div>
            <div class="content">
              <span>管理人性化</span>
              <span style="margin-left:20px">过程精细化</span>
              <span style="margin-left:20px">手段信息化</span>
              <span style="margin-left:20px">目标责任化</span>
            </div>
          </div>
        </div>
        <div class="right">
          <!-- <img src="../../assets/image/video.jpg" /> -->
          <!-- <video class="groupVideo" controls="controls"  preload="none"  src="../../assets/image/d76c1d17199ee1e9802fb75368b06f27.mp4" autoplay="autoplay" loop="loop" poster="../../assets/image/video.jpg" >
            <source src="../../assets/image/d76c1d17199ee1e9802fb75368b06f27.mp4" type="video/mp4">
          </video>  -->
          <div class="NewsVideo">
            <video class="groupVideo" controls="" preload="none"  src="../../assets/image/video.mp4"   muted="" poster="../../assets/image/video.jpg" autoplay="autoplay" style="width: 500px; height: 371px; ">
              <source src="../../assets/image/video.mp4" type="video/mp4">
            </video>                   
          </div>
        </div>
      </div>
    </div>
    <!-- 链接 -->
    <div class="oabangong">
      <div style="width:1200px;margin: 0 auto;">
        <a href="/homePage" target="_blank"
          ><img src="../../assets/image/00001.png" style="margin-top:40px;cursor: pointer;"
        /></a>
        <a href="https://www.xuexi.cn/" target="_blank"
          ><img src="../../assets/image/02.png" style="margin-top:40px;cursor: pointer;"
        /></a>
        <a href="http://oa.gsjtw.cc:8089/ekp/login.jsp" target="_blank"
          ><img src="../../assets/image/03.png" style="margin-top:40px;cursor: pointer;"
        /></a>
        <a href="http://oa.gsjtw.cc:8089/ekp/login.jsp" target="_blank"
          ><img src="../../assets/image/04.png" style="margin-top:40px;cursor: pointer;"
        /></a>
        <!-- <a href="/report" target="_blank"
          > -->
          <img src="../../assets/image/06.png" style="margin-top:40px;cursor: pointer;"/>
        <!-- </a> -->
      </div>
    </div>
    <!-- 党群工作 -->
    <div class="homeMain" style="margin-top: 30px;">
      <div class="dangqun_content">
        <div class="left">
          <img style="float: right;margin-bottom: 15px;" src="../../assets/image/LastDiv01.jpg" />
          <a class="dangqun_a">
            <div style="width:536px;height:220px;overflow: hidden;">
              <img
                class="dangqun_img"
                :src="dangqunList01Hdimg.thumb1"
                @click="
                  val => {
                    todel5(val, dangqunList01[0])
                  }
                "
              />
            </div>
          </a>
          <a
            class="dangqun_a1"
            @click="
              val => {
                todel5(val, dangqunList01Hd)
              }
            "
          >
            <div class="l">
              <span style="font-size: 28px;">{{ dayjs(dangqunList01Hd.publishDate).format('DD') }}</span
              ><br />
              <span>{{ dayjs(dangqunList01Hd.publishDate).format('YYYY-MM') }}</span>
            </div>
            <div class="r">
              {{ dangqunList01Hd.title }}
            </div>
          </a>
          <div class="ItemList" id="NewsItem">
            <div class="NewsItem">
              <ul class="comUl" style="margin: 0;">
                <li v-for="(item, index) in dangqunList01" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <a
                    v-else
                    @click="
                      val => {
                        todel5(val, item)
                      }
                    "
                    >{{ item.title }}</a
                  >
                  <span>{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="right">
          <img style="float: right;margin-bottom: 15px;" src="../../assets/image/LastDiv02.jpg" />
          <a class="dangqun_a">
            <div style="width:536px;height:220px;overflow: hidden;">
              <img
                class="dangqun_img"
                :src="dangqunList02Hdimg.thumb1"
                @click="
                  val => {
                    todel6(val, dangqunList02[0])
                  }
                "
              />
            </div>
          </a>
          <a
            class="dangqun_a1"
            @click="
              val => {
                todel6(val, dangqunList02Hd)
              }
            "
          >
            <div class="l">
              <span style="font-size: 28px;">{{ dayjs(dangqunList02Hd.publishDate).format('DD') }}</span
              ><br />
              <span>{{ dayjs(dangqunList02Hd.publishDate).format('YYYY-MM') }}</span>
            </div>
            <div class="r">
              {{ dangqunList02Hd.title }}
            </div>
          </a>
          <div class="ItemList" id="NewsItem">
            <div class="NewsItem">
              <ul class="comUl" style="margin: 0;">
                <li v-for="(item, index) in dangqunList02" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <a
                    v-else
                    @click="
                      val => {
                        todel6(val, item)
                      }
                    "
                    >{{ item.title }}</a
                  >
                  <span>{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 间隔 -->
    <div class="clear"></div>
    <!-- 精品项目轮播图 -->
    <div class="Jpgcw width_100">
      <div class="main_panel Pcn" style="margin: 20px auto 10px auto;">
        <a href="/projectShow/00580002" style="color: #0162b3; font-size: 30px; font-weight: bold;" target="_blank">
          <img src="../../assets/image/CaseT.jpg" />
        </a>
      </div>
      <a class="Pen" href="/projectShow/00580002" target="_blank">
        甘肃二建集团曾参与建设多项国内外、省内外重点工程建设项目，获得了良好的社会信誉。<br />
        近十年来，先后有3项工程获得国家建筑业最高奖——鲁班奖，获得全国建筑安全奖2项，获得甘肃省科技进步奖7项。有3项工程被评为甘肃省科技示范工程，<br />
        获得6项省级工法。近百项工程获得甘肃省建筑工程“飞天金奖”、“飞天奖”和地方各类质量奖项及“文明工地”称号。
      </a>
      <div class="main_panel" id="Jpgc">
        <div class="JpgcSwiper-container  swiper-container" id="jpgcPhoto">
          <div class="JpgcSwiper-wrapper swiper-wrapper">
            <div class="JpgcSwiper-slide swiper-slide" v-for="(item, index) in JpgcList" :key="index">
              <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" class="JpItem">
                <div class="img">
                  <img class="swiper_img" :src="item.thumb1" style="width: 100%; height: 242px;" />
                </div>
                <div class="Tit">{{ item.title }}</div>
                <div class="nr"></div>
              </a>
              <a
                v-else
                @click="
                  val => {
                    todel7(val, item.entTArticleUuid)
                  }
                "
                class="JpItem"
              >
                <div class="img">
                  <img class="swiper_img" :src="item.thumb1" style="width: 100%; height: 242px;" />
                </div>
                <div class="Tit">{{ item.title }}</div>
                <div class="nr">
                  查看详情
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 飘窗 -->
    <window-box ref="windowBox" style="margin-top: 30px;"></window-box>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { articles, getTopArtList, picArticles, picArticlesSecond } from '@/api/common'
import windowBox from '@/components/windowBox/index.vue'
export default {
  components: {
    windowBox
  },
  data() {
    return {
      dangqunList01Hd: {},
      dangqunList02Hd: {},
      dangqunList01: [],
      dangqunList02: [],
      isShowv: false,
      active: 0,
      ismouseover: true,
      indexImg: '',
      indexUrl: '',
      // 头条新闻轮播内容
      newsTextList: [],
      //精品工程轮播图
      JpgcList: [],

      //新闻目录
      catalogActive: 0,
      catalogList: [
        {
          id: 1,
          url: '/pressCenter/00550001',
          title: '集团要闻'
        },
        {
          id: 2,
          url: '/pressCenter/00550002',
          title: '基层动态'
        },
        {
          id: 3,
          url: '/pressCenter/00550003',
          title: '建投要闻'
        },
        {
          id: 4,
          url: '/pressCenter/00550004',
          title: '行业新闻'
        }
      ],
      //新闻列表
      newtitleList: [],
      newCatalogList01: [],
      newCatalogList02: [],
      newCatalogList03: [],
      newCatalogList04: [],
      // newCatalogList05: [],
      newsFlashList01: [],
      // newsFlashList02: [],
      // newsFlashList03: [],
      // newsFlashList04: [],
      // newsFlashList05: [],
      dangqunList01Hdimg: {},
      dangqunList02Hdimg: {}
    }
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 100) {
        return value.slice(0, 100) + '...'
      }
      return value
    },
    capitalize: function(value) {
      if (!value) return ''
      if (value.length > 40) {
        return value.slice(0, 40) + '...'
      }
      return value
    }
  },

  mounted() {
    var _this = this
    this.bannerNews()
    this.bannerJpgc()

    _this.picArticles()
    _this.newsCatalog()
  },
  methods: {
    // 跳转到新闻头条
    todel(val, item) {
      let routeUrl = this.$router.resolve({
        path: `/pressCenter/${item.entTChannelUuid}`,
        query: {
          entTArticleUuid: JSON.stringify(item.entTArticleUuid)
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    //建投要闻
    todeljt(val, item) {
      let routeUrl = this.$router.resolve({
        path: `/pressCenter/00550003`,
        query: {
          entTArticleUuid: JSON.stringify(item.entTArticleUuid)
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    togrop() {
      let routeUrl = this.$router.resolve('/groupProfile/00540001')
      window.open(routeUrl.href, '_blank')
    },
    todel5(val, item) {
      let routeUrl = this.$router.resolve({
        path: `/businessUnit/${item.entTChannelUuid}`,
        query: {
          entTArticleUuid: JSON.stringify(item.entTArticleUuid)
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    todel6(val, item) {
      let routeUrl = this.$router.resolve({
        path: `/culture/${item.entTChannelUuid}`,
        query: {
          entTArticleUuid: JSON.stringify(item.entTArticleUuid)
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    todel7(val, entTArticleUuid) {
      let routeUrl = this.$router.resolve({
        path: `/projectShow/00580002`,
        query: {
          entTArticleUuid: JSON.stringify(entTArticleUuid)
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    // 打开左右箭头
    openShow() {
      this.isShowv = true
    },
    closeShow() {
      this.isShowv = false
    },

    // 新闻焦点图
    picArticles() {
      var _this = this
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0055',
        pageNum: 1,
        pageSize: 6
      }
      picArticlesSecond(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsFlashList01 = data.rows
          this.$nextTick(() => {
            new Swiper('#newsFlash01', {
              // loop: true,
              // autoplay: {
              //   delay: 4000,
              //   disableOnInteraction: false //1秒切换一次
              // },
              // observer: true,
              // observeParents: true,
              // observeSlideChildren: true
              autoplay: 3000,
              speed: 300,
              loop: true,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
    },
    // 新闻动态-右
    newsCatalog() {
      var _this = this
      //党群工作
      let data1 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0060',
        pageNum: 1,
        pageSize: 8
      }
      articles(data1).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.dangqunList01Hd = data.rows[0]
          _this.dangqunList01 = data.rows
        }
      })
      picArticlesSecond(data1).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.dangqunList01Hdimg = data.rows[0]
        }
      })
      //职工文苑
      let data2 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0059',
        pageNum: 1,
        pageSize: 8
      }
      articles(data2).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.dangqunList02 = data.rows
          _this.dangqunList02Hd = data.rows[0]
        }
      })
      picArticlesSecond(data2).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.dangqunList02Hdimg = data.rows[0]
        }
      })

      // 集团要闻
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00550001',
        pageNum: 1,
        pageSize: 8
      }
      articles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newCatalogList01 = data.rows
        }
      })

      // 媒体聚焦
      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00550002',
        pageNum: 1,
        pageSize: 8
      }
      articles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newCatalogList02 = data.rows
        }
      })

      // 电视新闻
      let data03 = {
        entTApplicationUuid: _this.webIdGroup,
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 8
      }
      articles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newCatalogList03 = data.rows
        }
      })

      // 深度报道
      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00550004',
        // channelUuid: '00550003',
        pageNum: 1,
        pageSize: 8
      }
      articles(data04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newCatalogList04 = data.rows
        }
      })
    },
    //热点资讯
    bannerNews() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getTopArtList(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsTextList = data[0]
        }
      })
    },

    //精品工程轮播图
    bannerJpgc() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00580002',
        pageNum: 1,
        pageSize: 10
      }
      picArticles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.JpgcList = data.rows
          this.$nextTick(() => {
            this.swiper = new Swiper('#jpgcPhoto', {
              loop: true,
              speed: 3000,
              autoplay: 1,
              slidesPerView: 4,
              spaceBetween: 10,
              observer: true,
              observeParents: true,
              observeSlideChildren: true
            })

            // 存放鼠标悬浮时的transform属性（行内属性）
            let nextTransForm = ''
            // 轮播图从暂停位置移动到原本应到的位置所用的时间
            let nextTime = 0

            // 鼠标悬浮暂停轮播
            this.swiper.container[0].onmouseover = function() {
              nextTransForm = document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform
              // 轮播图原本应移动到的位置
              let nextTransPosition =
                -1 *
                parseInt(
                  document
                    .getElementsByClassName('JpgcSwiper-container')[0]
                    .getElementsByClassName('swiper-wrapper')[0]
                    .style.transform.split('translate3d(')[1]
                    .split('px')[0]
                )

              // 鼠标悬浮时时轮播图位置
              let nowTransPosition =
                -1 *
                parseInt(
                  window
                    .getComputedStyle(
                      document
                        .getElementsByClassName('JpgcSwiper-container')[0]
                        .getElementsByClassName('swiper-wrapper')[0],
                      false
                    )
                    ['transform'].split('1, ')[2]
                    .split(',')[0]
                )
              // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
              let nowTransForm = window.getComputedStyle(
                document.getElementsByClassName('JpgcSwiper-container')[0].getElementsByClassName('swiper-wrapper')[0],
                false
              )['transform']
              // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
              nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
              // 改变行内transform属性
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
              // 不写也没关系
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
              this.swiper.stopAutoplay()
            }
            // 鼠标离开轮播图开始轮播
            this.swiper.container[0].onmouseout = function() {
              // console.log('leave' + nextTransForm)
              // 恢复原样
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
              document
                .getElementsByClassName('JpgcSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
              this.swiper.startAutoplay()
            }
          })
        }
      })
    },

    mouseChange(val, index) {
      // console.log(val)
      this.active = index
      // this.indexImg = val.fileName
      if (val.url && val.url !== '') {
        this.indexUrl = val.url
      } else {
        this.indexUrl = `/businessUnit/${val.entTChannelUuid}`
      }
    },
    mouseenterCatalog(val) {
      var _this = this

      _this.catalogActive = val
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';

#Jpgc {
  .swiper-container .swiper-wrapper {
    -webkit-transition-timing-function: linear;
    /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
  }
}

.main_panel_top {
  margin-top: 40px;
  cursor: pointer;

  .main_panel_span:hover {
    color: #4d4d44d4;
  }
}

.main_panel_content {
  .left {
    width: 667px;
    float: left;

    .button {
      width: 107px;
      height: 30px;
      background-color: #0353aa;
      color: #ffffff;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      float: left;
    }

    .content {
      width: 540px;
      overflow: hidden;
      line-height: 30px;
      font-weight: bold;
      float: right;
    }
  }

  .right {
    width: 483px;
    height: 371px;
    float: right;
  }
}

.dangqun_content {
  margin-top: 30px;

  .dangqun_img {
    height: 100%;
    width: 100%;
    cursor: pointer;
    transition: all 1s linear;
    -webkit-transition: 1s all linear;
    /* 适用Safari 和 Chrome兼容 */
    -moz-transition: 1s all linear;
    /* 适用Firefox兼容 */
    -ms-transition: 1s all linear;
    /* 适用IE9兼容 */
    -o-transition: 1s all linear;
    /* Opera */
  }

  .dangqun_img:hover {
    -webkit-transform: scale(1.2);
    /*在Safari 和 Chrome兼容下还原*/
    -moz-transform: scale(1.2);
    /*在Firefox兼容下还原*/
    -ms-transfrom: scale(1.2);
    /*在IE9兼容下还原*/
    -o-transform: scale(1.2);
    /*在opera兼容下还原*/
    transform: scale(1.2);
    /*适用于所有浏览兼容下还原*/
  }

  .dangqun_a1 {
    width: 100%;
    height: 72px;
    display: block;
    overflow: hidden;
    margin-top: 15px;
    margin-bottom: 10px;
    cursor: pointer;

    .l {
      width: 60px;
      height: 60px;
      border: 1px #dcdcdc solid;
      float: left;
      padding: 5px;
      text-align: center;
      color: #a8a6a7;
      font-size: 14px;
    }

    .r {
      width: 455px;
      line-height: 30px;
      font-size: 18px;
      float: right;
      padding-top: 5px;
    }
  }

  .left {
    width: 548px;
    float: left;

    .dangqun_a {
      width: 536px;
      height: 220px;
      overflow: hidden;
      padding: 5px;
      border: 1px #d3d3d3 solid;
      display: block;
    }
  }

  .right {
    width: 548px;
    float: right;

    .dangqun_a {
      width: 536px;
      height: 220px;
      overflow: hidden;
      padding: 5px;
      border: 1px #d3d3d3 solid;
      display: block;
    }
  }
}

.homePage {
  width: 100%;
  height: auto;
  overflow: hidden;
}

// 轮播背景大图
.homePage .ziHead {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.homePage .ziHead .swiper-container {
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      text-align: center;
      position: relative;
      overflow: hidden;
      height: 540px;
    }
  }
}

.homePage .ziHead .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url('../../assets/image/leftimg.png');
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}

.homePage .ziHead .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url('../../assets/image/rightimg.png');
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}

.homePage .ziHead .swiper-button-prev {
  left: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}

.homePage .ziHead .swiper-button-next {
  right: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}

.homePage .ziHead .swiper-button-prev.active {
  left: 10px;
}

.homePage .ziHead .swiper-button-next.active {
  right: 10px;
}

.homePage .homeMain {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}

.homePage .homeMain .main_panel {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}

// 头条新闻部分
.homePage .homeMain .Notice {
  height: auto;
  overflow: hidden;
  line-height: 24px;
}

.homePage .homeMain .Notice .Tit {
  width: 126px;
  height: 151px;
  overflow: hidden;
  float: left;
}

.homePage .homeMain .Notice .Tit img {
  border: 0px;
  vertical-align: middle;
}

.homePage .homeMain .Notice .r {
  width: 1023px;
  float: right;
  overflow: hidden;
}

.homePage .homeMain .Notice .r h2 {
  color: #000000;
  font-weight: bold;
  text-align: center;
  line-height: 35px;
  font-size: 26px;
  width: 100%;
  height: 35px;
  overflow: hidden;
}

.homePage .homeMain .Notice .r h2:hover {
  color: #717171;
  cursor: pointer;
}

.homePage .homeMain .Notice .r .homeText {
  color: #717171;
  text-align: center;
  line-height: 28px;
  overflow: hidden;
}

.homePage .homeMain .Notice .r .swiper-pagination-news .swiper-pagination-bullet {
  width: 40px;
  height: 4px;
  border-radius: 0px;
}

.homePage .homeMain .Notice .r .swiper-pagination-news .swiper-pagination-bullet-active {
  background-color: #e70604;
}

.homePage
  .homeMain
  .Notice
  .r
  .swiper-pagination-news
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: -3px 4px;
}

// 间隔部分
.homePage .homeMain .clear {
  width: 100%;
  height: 10px;
  clear: both;
  overflow: hidden;
}

// 新闻动态部分
.homePage .homeMain .NewsL {
  width: 520px;
  overflow: hidden;
  float: left;
}

.homePage .homeMain .NewsL .Tit {
  width: 100%;
  height: 53px;
  background: url(../../assets/image/newsLine.jpg) bottom repeat-x;
}

.homePage .homeMain .NewsL .Tit .en {
  width: 65px;
  font-size: 20px;
  color: #000000;
  float: right;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-top: 14px;
}

.homePage .homeMain .NewsL .Tit .cn {
  width: 130px;
  font-size: 24px;
  color: #0162b3;
  float: right;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-top: 10px;
}

.homePage .homeMain .NewsL .flashImg {
  width: 520px;
  height: 360px;
  overflow: hidden;
}

.homePage .homeMain .NewsL .flashImg:hover {
  cursor: pointer;
}

.homePage .homeMain .NewsL .flashImg-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.homePage .homeMain .NewsL .flashImg-slide {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.homePage .homeMain .NewsL .flashImg-slide .swiper_img {
  height: 100%;
  width: 100%;
  overflow: hidden;

  transition: all 2s ease-in;
  -webkit-transition: 2s all ease-in;
  /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 2s all ease-in;
  /* 适用Firefox兼容 */
  -ms-transition: 2s all ease-in;
  /* 适用IE9兼容 */
  -o-transition: 2s all ease-in;
  /* Opera */
}

.homePage .homeMain .NewsL .flashImg-slide .swiper_img:hover {
  overflow: hidden;
  -webkit-transform: scale(1.2);
  /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.2);
  /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.2);
  /*在IE9兼容下还原*/
  -o-transform: scale(1.2);
  /*在opera兼容下还原*/
  transform: scale(1.2);
  /*适用于所有浏览兼容下还原*/
}

.homePage .homeMain .NewsL .flashImg .flashImg-slide .txt {
  // width: 665px;
  // height: 72px;
  overflow: hidden;
  background-color: #000000;
  margin-top: -40px;
  z-index: 2;
  opacity: 0.7;
}

.homePage .homeMain .NewsL .flashImg .txt .txtTitle {
  font-size: 16px;
  line-height: 36px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  overflow: hidden;
  /*超出部分隐藏*/
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  white-space: nowrap;
  /*规定段落中的文本不进行换行 */
  width: 100%;
  /*需要配合宽度来使用*/
}

.NewsL .flashImg .txt .txtContent {
  overflow: hidden;
  line-height: 24px;
  font-size: 13px;
  color: #dadee3;
  text-indent: 24px;
  font-family: '宋体';
  margin: 0 auto;

  // 同一行超出文本使用省略号显示，设置宽度代码
  // overflow: hidden;/*超出部分隐藏*/
  // text-overflow:ellipsis;/* 超出部分显示省略号 */
  // white-space: nowrap;/*规定段落中的文本不进行换行 */
  // width: 620px;/*需要配合宽度来使用*/
}

.homePage .homeMain .NewsL #newsFlash .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url(../../assets/image/z.png);
  background-size: 18px 24px;
}

.homePage .homeMain .NewsL #newsFlash .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url(../../assets/image/y.png);
  background-size: 18px 24px;
}

//新闻列表部分
.homePage .homeMain .NewsR {
  width: 645px;
  float: right;
  overflow: hidden;
}

.homePage .homeMain .NewsR .Tit {
  width: 100%;
  height: 40px;
  overflow: hidden;
}

.homePage .homeMain .NewsR .Tit a {
  width: 100px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  display: block;
  float: left;
  font-size: 16px;
  margin-right: 1px;
  background-color: #dfdfdf;
  color: #666666;
}

a,
a:focus,
a:hover {
  text-decoration: none;
}

.homePage .homeMain .NewsR .Tit a:hover {
  color: #fff;
  background-color: #0162b3;
}

.homePage .homeMain .NewsR .NewsTInner.active a {
  color: #fff;
  background-color: #0162b3;
}

.homePage .ItemList {
  width: 100%;
  overflow: hidden;
}

.homePage .ItemList .comUl {
  padding-left: 0px;
  // margin: 0;
}

.homePage .ItemList .comUl li {
  width: 100%;
  height: 38.4px;
  line-height: 38.4px;
  background: url(../../assets/image/li.jpg) left center no-repeat;
  text-indent: 1.2em;
}

.homePage .ItemList .comUl li a {
  float: left;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  color: #000000;
  font-size: 15px;
}

.homePage .ItemList .comUl li a:hover {
  animation: comUla 0.2s linear 1;
  color: #4d4d44d4;
}

@keyframes comUla {
  from {
    transform: translateY(+1px);
  }

  to {
    transform: translateY(+1px);
  }
}

.comUl li span {
  float: right;
  font-size: 15px;
}

// 重要公告部分
.homePage .homeMain .importNotice {
  height: 54px;
  background: #f2f2f2;
  line-height: 54px;
  margin: 20px auto;
}

.homePage .homeMain .importNotice .t {
  width: 120px;
  height: 54px;
  overflow: hidden;
  float: left;
  font-size: 16px;
  color: #ff0000;
  text-align: right;
  margin-left: 10px;
  background: url(../../assets/image/importNotice.png) left center no-repeat;
  font-weight: bold;
}

.homePage .homeMain .importNotice .Gd {
  height: 54px;
  overflow: hidden;
  float: left;
  margin-left: 10px;
}

.homePage .homeMain .importNotice #demoLeft1 {
  float: left;
  overflow: hidden;
  width: 1040px;
}

.homePage .homeMain .importNotice #demoLeft1 .indemo {
  width: 800%;
}

.homePage .homeMain .importNotice #demo1,
#demo2 {
  float: left;
}

.homePage .homeMain .importNotice .clear {
  width: 100%;
  height: 10px;
  clear: both;
  overflow: hidden;
}

// 业务板块 甘肃建投 中国500强企业
.homePage .importYeWu {
  height: 220px;
  overflow: hidden;
  margin-top: 45px;
  background: url(../../assets/image/bwcxljsm.jpg) center no-repeat;
  background-size: cover;
}

.oabangong {
  height: 225px;
  overflow: hidden;
  margin-top: 35px;
  background: url(../../assets/image/Links.jpg) center no-repeat;
  background-size: cover;
}

.homePage .width_100 {
  width: 100% !important;
}

.homePage .text-center {
  text-align: center;
}

.homePage .importYeWu .Item {
  height: 476px;
  // overflow: hidden;
  margin-top: 7px;
}

.homePage .importYeWu .main_panel {
  width: 1200px;
  height: auto;
  // overflow: hidden;
  margin: 0 auto;
}

.homePage .importYeWu .Item .Left {
  width: 244px;
  height: 476px;
  // overflow: hidden;
  position: absolute;
  z-index: 2;
  float: left;
}

.homePage .importYeWu .Item .Left ul {
  margin: 0;
  padding: 0;
}

.homePage .importYeWu .Item .Left ul li {
  width: 95%;
  height: 68px;
  // overflow: hidden;
  border-bottom: 1px #cfcfcf solid;
}

li {
  list-style: none;
}

.homePage .importYeWu .Item .Left ul li img {
  float: right;
  margin-right: -40px;
  margin-top: -49px;
}

.homePage .importYeWu .Item .Left ul li a {
  width: 258px;
  height: 68px;
  display: block;
  background-color: #3fb2e1;
  border-bottom: 1px #cfcfcf solid;
  text-align: center;
  line-height: 68px;
  font-size: 18px;
  // overflow: hidden;

  color: #ffffff;
}

.homePage .importYeWu .Item .Left ul a:hover {
  color: #fff;
  background-color: #0162b3;
}

.homePage .importYeWu .Item .Left ul a:active {
  color: #fff;
  background-color: #0162b3;
}

.homePage .importYeWu .Item .Left ul li.active a {
  color: #fff;
  background-color: #0162b3;
}

.homePage .importYeWu .Item .Left ul li img {
  display: none;
}

.homePage .importYeWu .Item .Left ul li img.active {
  display: block;
}

.homePage .importYeWu .Item .Right {
  width: 956px;
  height: 482px;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  margin-left: 258px;
}

.homePage .importYeWu .Item .Right a {
  width: 956px;
  height: 482px;
  overflow: hidden;
  display: block;
}

a,
a:focus,
a:hover {
  text-decoration: none;
}

.homePage .importYeWu .Item .Right img {
  height: 100%;
  width: 100%;
  transition: all 2s ease-in;
  -webkit-transition: 2s all ease-in;
  /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 2s all ease-in;
  /* 适用Firefox兼容 */
  -ms-transition: 2s all ease-in;
  /* 适用IE9兼容 */
  -o-transition: 2s all ease-in;
  /* Opera */
}

.homePage .importYeWu .Item .Right img:hover {
  transform: scale(1.2);
  -webkit-transform: scale(1.2);
  /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.2);
  /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.2);
  /*在IE9兼容下还原*/
  -o-transform: scale(1.2);
  /*在opera兼容下还原*/
  transform: scale(1.2);
  /*适用于所有浏览兼容下还原*/
}

// 各种链接，网站集群

.homePage .Links {
  margin-top: 25px;
  // height: 225px;
  height: auto;
  background: url(../../assets/image/Links.jpg) center center no-repeat;
  background-size: cover;
}

.homePage .Links .main_panel {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}

.homePage .Links .P1 {
  width: 440px;
  height: 196px;
  padding: 15px 0px 15px 120px;
  background: #ffffff url(../../assets/image/Broad.png) left center no-repeat;
  opacity: 0.6;
  float: left;
  margin-top: 20px;
  box-sizing: border-box;
}

.homePage .Links .ct {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #0162b3;
  font-size: 20px;
  font-weight: bold;
}

.homePage .Links p {
  line-height: 26px;
  color: #0162b3;
  padding-left: 5px;
  padding-top: 10px;
}

.homePage .Links .P1 a,
a:focus,
a:hover {
  text-decoration: none;
}

.homePage .Links .P1 a {
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  color: #000000;
}

.homePage .Links .P2 {
  width: 370px;
  height: 213px;
  margin-top: 20px;
  float: left;
  margin-left: 15px;
}

.homePage .Links .P2 a:hover .en {
  animation: myEn 0.5s linear 1;
}

@keyframes myEn {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-6px);
  }
}

.homePage .Links .P2 a:hover .cn {
  animation: myCn 0.5s linear 1;
}

@keyframes myCn {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(6px);
  }
}

.homePage .Links .P2 .L1 {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  opacity: 0.6;
  text-align: center;
}

.homePage .Links .P2 .cn {
  color: #0162b3;
  font-size: 24px;
  font-weight: bold;
  height: 36px;
  line-height: 36px;
}

.homePage .Links .P2 .L2 {
  width: 164px;
  height: 54px;
  float: left;
  display: block;
  background-color: #ffffff;
  opacity: 0.6;
}

.homePage .Links .P2 .L2 .cn {
  margin-left: 25px;
  height: 22px;
  line-height: 22px;
  letter-spacing: 2px;
  margin-top: 6px;
}

.homePage .Links .P2 .L2 .en {
  margin-top: 0px;
  margin-left: 25px;
  height: 30px;
  display: inline-block;
  color: #0162b3;
  font-size: 12px;
  font-weight: bold;
}

.homePage .Links .P3 {
  width: 347px;
  height: 213px;
  margin-top: 20px;
  float: left;
  margin-left: 20px;
}

.homePage .Links .P3 .t {
  text-align: center;
  width: 53px;
  height: 180px;
  float: left;
  font-size: 20px;
  color: #0162b3;
  font-weight: bold;
  background-color: #ffffff;
  opacity: 0.6;
  line-height: 24px;
  padding-top: 15px;
}

.homePage .Links .P3 .en {
  width: 100px;
  height: 53px;
  position: absolute;
  z-index: 2;
  transform: rotate(90deg);
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-left: -38px;
  margin-top: 140px;
  color: #0162b3;
}

.homePage .Links .P3 .nr {
  width: 303px;
  height: 195px;
  float: left;
  background-color: #ffffff;
  opacity: 0.6;
  margin-left: 54px;
  position: absolute;
  z-index: 2;
}

.homePage .Links .P3 .nr .link-container {
  margin: 2px auto 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 4px 0 10px 0;
  z-index: 1;
  width: 100%;
  height: 194px;
  box-sizing: border-box;
}

.homePage .Links .P3 .nr .link-container .swiper-slide {
  font-size: 18px;
  height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 4px;
  width: 100%;
}

.homePage .Links .P3 .nr .link-container .swiper-slide .aItem {
  width: 95%;
  height: 30px;
  line-height: 28px;
  font-size: 14px;
  display: block;
  float: none;
  margin: 0px auto 0px auto;
  overflow: hidden;
  /*超出部分隐藏*/
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  white-space: nowrap;
  /*规定段落中的文本不进行换行 */
}

.homePage .Links .P3 .nr .link-container .swiper-slide a:hover {
  color: #0162b3;
}

// 精品项目轮播图
.homePage .Jpgcw {
  margin-top: 30px;
  overflow: hidden;
}

.homePage .Jpgcw .Pcn {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #0162b3;
  font-size: 30px;
  font-weight: bold;
}

.homePage .Jpgcw .Pen {
  width: 100%;
  text-align: center;
  line-height: 26px;
  color: #404040;
  font-size: 16px;
  display: block;
}

.homePage .Jpgcw .Pcn,
.Pen:hover {
  cursor: pointer;
}

#Jpgc {
  overflow: hidden;
  position: static;
}

.homePage .Jpgcw .main_panel {
  width: 1200px;
  height: auto;
  margin: 20px auto 0 auto;
}

.homePage .Jpgcw .jpmore {
  width: 100px;
  height: 36px;
  background-color: #0162b3;
  display: block;
  color: #ffffff;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  margin: 0 auto;
  border-radius: 3px;
}

#Jpgc .JpgcSwiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  position: inherit;
  list-style: none;
  padding: 0;
  z-index: 1;
}

#Jpgc .JpgcSwiper-container .swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  box-sizing: content-box;
}

#Jpgc .JpgcSwiper-container .swiper-slide {
  text-align: center;
  font-size: 18px;
  width: 380px;
  margin-right: 30px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

#Jpgc .JpItem {
  width: 283px;
  display: block;
  overflow: hidden;
}

#Jpgc .JpItem .img {
  width: 283px;
  height: 197px;
  overflow: hidden;
}

#Jpgc .JpItem .img img {
  transition: all 0.5s ease-in;
  -webkit-transition: 0.5s all ease-in;
  /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 0.5s all ease-in;
  /* 适用Firefox兼容 */
  -ms-transition: 0.5s all ease-in;
  /* 适用IE9兼容 */
  -o-transition: 0.5s all ease-in;
  /* Opera */
}

#Jpgc .JpItem .Tit {
  width: 100%;
  height: 30px;
  text-align: center;
  margin: 5px 0px;
  line-height: 30px;
  font-weight: bolder;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  color: #424242;
}

#Jpgc .JpItem .nr,
.Tit:hover {
  cursor: pointer;
}

#Jpgc .JpItem .nr {
  width: 96px;
  height: 30px;
  border: 1px #d2d2d2 solid;
  line-height: 30px;
  text-align: center;
  color: #ec0404;
  margin: 10px auto 0px auto;
  font-size: 13px;
}

#Jpgc .JpItem .img {
  width: 100%;
  height: 197px;
  overflow: hidden;
}

#Jpgc .JpItem:hover .img img {
  transform: scale(1.2);
  -webkit-transform: scale(1.2);
  /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.2);
  /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.2);
  /*在IE9兼容下还原*/
  -o-transform: scale(1.2);
  /*在opera兼容下还原*/
  transform: scale(1.2);
  /*适用于所有浏览兼容下还原*/
  cursor: pointer;
}

#Jpgc .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  top: auto;
  margin-top: -215px;
  left: auto;
  background-image: none;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../../assets/image/z.png);
  margin-left: -40px;
  // right: 0;
}

#Jpgc .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  top: auto;
  margin-top: -215px;
  left: auto;
  background-image: none;
  // margin-right: -50px;
  margin-left: 1210px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../../assets/image/y.png);
  list-style: none;
}
</style>
